/*
 * Hymnal Intelligence · Parish Library Availability chip
 * ---------------------------------------------------------------------
 * Renders "Available in your parish library · Lumen Christi Hymnal · #151"
 * beneath a recommendation. Zero fabrication: this component renders
 * ONLY the availability array supplied by the backend
 * `resolve_hymnal_availability` resolver.
 * =================================================================== */
import React from "react";
import "./hymnal-availability.css";

export default function HymnalAvailability({ availability = [] }) {
  if (!availability || !availability.length) return null;
  return (
    <div className="hi-availability" aria-label="Parish library availability" data-testid="hi-availability">
      {availability.map((item) => (
        <div
          key={`${item.source_id}-${item.hymn_number}-${item.title_as_printed}`}
          className="hi-availability__item"
          data-testid={`hi-availability-item-${item.source_id}-${item.hymn_number}`}
        >
          <span className="hi-availability__label">Available in your parish library</span>
          <span className="hi-availability__source">
            {item.source_name}
            {" · #"}
            {item.hymn_number}
          </span>
        </div>
      ))}
    </div>
  );
}
